import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { translations } from '../locales/translations';
import LanguageSelector from './LanguageSelector';

function Navbar({ lang = 'ko', onLanguageChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const t = translations[lang];

  return (
    <nav className="bg-white/90 backdrop-blur-sm fixed w-full z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0">
              <h1 className="text-2xl md:text-3xl font-title font-bold text-primary hover:text-secondary transition-colors duration-300">
                {lang === 'ko' ? '한소망교회' : 'Hansomang Church'}
              </h1>
            </Link>
          </div>

          <div className="hidden md:flex md:items-center md:space-x-8">
            <Link 
              to="/"
              className="text-lg font-heading font-bold text-primary hover:text-secondary transition-colors duration-300"
            >
              {t.nav.home}
            </Link>
            <Link 
              to="/about"
              className="text-lg font-heading font-bold text-primary hover:text-secondary transition-colors duration-300"
            >
              {t.nav.about}
            </Link>
            <Link 
              to="/worship"
              className="text-lg font-heading font-bold text-primary hover:text-secondary transition-colors duration-300"
            >
              {t.nav.worship}
            </Link>
            <Link 
              to="/contact"
              className="text-lg font-heading font-bold text-primary hover:text-secondary transition-colors duration-300"
            >
              {t.nav.contact}
            </Link>
            <a 
              href="tel:02-887-6696" 
              className="text-lg font-heading font-bold text-primary hover:text-secondary transition-colors duration-300 tracking-wide"
            >
              02-887-6696
            </a>
            <LanguageSelector currentLang={lang} onLanguageChange={onLanguageChange} />
          </div>

          {/* 모바일 메뉴 버튼 */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-primary hover:text-secondary focus:outline-none"
            >
              {isOpen ? (
                <XMarkIcon className="h-6 w-6" />
              ) : (
                <Bars3Icon className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* 모바일 메뉴 */}
      <div className={`${isOpen ? 'block' : 'hidden'} md:hidden bg-white`}>
        <div className="px-2 pt-2 pb-3 space-y-1">
          <Link 
            to="/"
            className="block px-3 py-2 text-base font-heading font-bold text-primary hover:text-secondary"
          >
            {t.nav.home}
          </Link>
          <Link 
            to="/about"
            className="block px-3 py-2 text-base font-heading font-bold text-primary hover:text-secondary"
          >
            {t.nav.about}
          </Link>
          <Link 
            to="/worship"
            className="block px-3 py-2 text-base font-heading font-bold text-primary hover:text-secondary"
          >
            {t.nav.worship}
          </Link>
          <Link 
            to="/contact"
            className="block px-3 py-2 text-base font-heading font-bold text-primary hover:text-secondary"
          >
            {t.nav.contact}
          </Link>
          <a 
            href="tel:02-887-6696"
            className="block px-3 py-2 text-base font-heading font-bold text-primary hover:text-secondary"
          >
            02-887-6696
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 